import moment from "moment";
export default {
  props: {
    contabile: Object,
  },
  data() {
    return {
      dialog: false,
      verde: this.contabile.verde,
      importo: Math.abs(this.contabile.importo).toFixed(2),
      menu_data: false,
      date: moment.unix(this.contabile.ts).format("YYYY-MM-DD"),
      items_tipo: [
        { id: 1, tipo: "Debito" },
        { id: 2, tipo: "Credito" },
      ],
      tipo: this.contabile.tipo,
      ordine: null,
      subordine: null,
      listaOrdini: [],
      ddt: this.contabile.ddt,
      note: this.contabile.note,
      loadingSalva: false,
      loadingOrdine: true,
      errorDialog: false,
      valid: false,
    };
  },
  mounted() {
    if (this.contabile) {
      this.ordine = this.contabile.id_ordine;
      if (this.contabile.id_subconteggio) {
        this.subordine = this.contabile.id_subconteggio;
      }
    }
  },
  computed: {
    cliente() {
      return this.$store.getters.get_cliente_by_iva(this.contabile.cliente);
    },
    dataFormatted() {
      return moment(this.date).format("dddd DD MMMM YYYY");
    },
    subConteggi() {
      let ordine = this.$store.getters.get_ordine_by_id(this.ordine);
      if (ordine) {
        if(ordine.subConteggio === undefined){
          return [];
        }
        return ordine.subConteggio.map((sub) => ({
          id: sub.id.$oid,
          numero: sub.subNumero,
        }));
      } else {
        return [];
      }
    },
  },
  watch: {
    verde() {
      this.ddt = null;
    },
    dialog: function () {
      if (this.dialog) {
        this.$store
          .dispatch("fetch_ordini_by_cliente", this.contabile.cliente)
          .then((ordini) => {
            this.listaOrdini = [
              { numero: "Nessun ordine", "_id.$oid": "" },
              ...ordini,
            ];
            // let ordine = this.$store.getters.get_ordine_by_id(
            //   this.contabile.id_ordine
            // );
            // if (ordine) {
            //   this.ordine = {};
            //   this.loadingOrdne = false;
            // } else {
            //   // Fetch ordine by id if not already available
            //   this.$store
            //     .dispatch("fetch_ordine_by_id", this.contabile.id_ordine)
            //     .then((ordine) => {
            //       this.ordine = ordine;
            //     })
            //     .finally(() => {
            //       this.loadingOrdne = false;
            //     });
            // }
          })
          .finally(() => {
            this.loadingOrdine = false;
          });
        this.loadingOrdne = true;
      }
    },
  },
  methods: {
    salvaContabile() {
      this.loadingSalva = true;
      this.$store
        .dispatch("update_contabile", {
          id: this.contabile.id,
          verde: this.verde,
          importo: this.tipo == 1 || this.tipo == 3 ? this.importo : -this.importo,
          ts: moment(this.date).format("X"),
          tipo: this.tipo,
          id_ordine: this.ordine,
          id_subconteggio: this.contabile.id_subconteggio,
          ddt: this.ddt,
          note: this.note,
        })
        .then(() => {
          this.loadingSalva = false;
          this.dialog = false;
          this.$emit("update-contabile");
        })
        .catch(() => {
          this.loadingSalva = false;
          this.errorDialog = true;
          setTimeout(() => {
            this.errorDialog = false;
          }, 2000);
        });
    },
  },
};
